import QRCode from "react-qr-code";

const AppDownloadGuide = () => {
  return (
    <div className="flex flex-col w-screen items-center">
      <div className="w-[360px] min-w-[360px] px-4 pt-8 pb-20">
        <div
          className="min-h-[441px] rounded-[12px] bg-cover bg-center bg-no-repeat overflow-hidden"
          style={{
            backgroundImage: "url('/images/mykeepin-install-hero.jpg')",
          }}
        >
          <p className="inset-x-0 top-0 py-8 px-6 text-center text-[#f94a46] text-[22px] font-bold">
            매번 번거로웠던 인증을 <br /> 마이키핀 하나로 관리해보세요
          </p>
        </div>
        <p className="px-12 mt-8 text-center text-[#333] text-sm leading-6 break-keep">
          스마트폰으로 QR코드를 스캔하면 설치페이지로 이동합니다.
        </p>
        <div className="flex mt-6">
          <div className="flex-1 px-3 mr-2">
            <p className="text-[#333] text-center break-keep">Android App</p>
            <div className="flex justify-center items-center mt-2  bg-white h-[136px]">
              <QRCode
                value={
                  "https://play.google.com/store/apps/details?id=com.coinplug.mykeepin"
                }
                size={112}
              />
            </div>
            <a className="block mt-[16px] h-12">
              <img
                className="cursor-pointer"
                src="/images/google-play-download-icon.png"
                alt="android-download"
                onClick={() =>
                  (window.location.href =
                    "https://play.google.com/store/apps/details?id=com.coinplug.mykeepin")
                }
              />
            </a>
          </div>
          <div className="flex-1 px-3">
            <p className="text-[#333] text-center break-keep">iOS App</p>
            <div className="flex justify-center items-center mt-2  bg-white h-[136px]">
              <QRCode
                value={`https://apps.apple.com/kr/app/${encodeURIComponent(
                  "마이키핀/id1479166844"
                )}`}
                size={112}
              />
            </div>
            <a className="block mt-[16px] h-12">
              <img
                className="cursor-pointer"
                src="/images/app-store-download-icon.png"
                alt="ios-download"
                onClick={() =>
                  (window.location.href = `https://apps.apple.com/kr/app/${encodeURIComponent(
                    "마이키핀/id1479166844"
                  )}`)
                }
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppDownloadGuide;
